<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7IbcGk/tc-custom/9781787198784.jpg?1705751371127" alt="This image is the cover for the book Necessary Murder, The Heloise Chancey Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Necessary Murder, The Heloise Chancey Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A string of murders cuts close to home for the Victorian courtesan and professional sleuth in this mystery thriller set in 19th century London.</b></p><p><i>London, 1863</i>: Little Margaret Lovejoy is found brutally murdered in the outhouse at her family’s estate. A few days later, a man is cut down in a similar manner on the doorstep of Heloise Chancey’s prestigious address. But the courtesan detective has other troubles to attend to. Heloise’s maid, Amah Li Leen, has just discovered that events from her past have resurfaced to threaten her present life.</p> Once again, Heloise is caught in a maelstrom of murder and deceit that threatens to dismantle her carefully crafted existence. But she has always been adept at deceiving the dishonest. Pursuing two investigations at once, Heloise is about to demonstrate just how skilled she truly is.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. J. Tjia
      </h2>
      
      <p class="authorDescription body article">M.J's father is Chinese-Indonesian and her mother has English-Irish heritage. Being Eurasian herself means that she has always been interested in portraying racially hybridised characters. Although M.J. grew up in Australia, she has always favoured British fiction, especially in the crime genre. Her inspirations include Agatha Christie, Allingham and Sayers, Val McDermid, Peter Robinson, R.D. Wingfield and Reginald Hill.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Legend Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24ea532e